<template>
  <div class="CourseLive_wrap replay-program-page">
    <div class="CourseLive_header">
      <div class="CourseLive_header__secssion">
        <div class="logo-m">
          <img src="~@/assets/images/LOGO_width.png" />
        </div>
        <div class="logo">
          <img src="~@/assets/images/logo_white.png" />
        </div>
      </div>
      <Headertitle
        :isListPage="true"
        :isPlayPage="false"
        :isexitPage="true"
        :associationScore="null"
        :specialistScore="null"
      />
    </div>

    <main class="program-main">
      <div v-if="loading" class="program-state">
        <v-progress-circular indeterminate color="primary" />
        <span>프로그램을 불러오는 중입니다.</span>
      </div>

      <div v-else-if="errorMessage" class="program-state error-state">
        <v-icon color="error">mdi-alert-circle-outline</v-icon>
        <span>{{ errorMessage }}</span>
        <v-btn color="primary" outlined @click="fetchProgram">다시 시도</v-btn>
      </div>

      <template v-else-if="program">
        <section class="program-intro">
          <div>
            <p class="eyebrow">제14회 A to Z 연수강좌</p>
            <h1>다시보기 프로그램</h1>
            <p class="period">
              이용 기간 {{ formatDate(program.available_from) }} ~ {{ formatDate(program.available_until) }}
            </p>
          </div>
        </section>

        <section class="program-table" aria-label="다시보기 프로그램 목록">
          <div class="ceremony-row">
            <span class="schedule-time">{{ program.opening.time }}</span>
            <strong>{{ program.opening.title }}</strong>
          </div>

          <div v-for="session in program.sessions" :key="session.id" class="session-block">
            <header class="session-header">
              <div class="session-number">Session {{ session.number }}</div>
              <div class="session-heading">
                <div>
                  <span class="session-time">{{ session.time }}</span>
                  <h2>{{ session.title }}</h2>
                </div>
                <p class="chair">좌장 {{ session.chair }}</p>
              </div>
            </header>

            <div class="lecture-list">
              <article v-for="lecture in session.lectures" :key="lecture.id" class="lecture-row">
                <div class="schedule-time">{{ lecture.time }}</div>
                <div class="lecture-content">
                  <div class="lecture-title-line">
                    <span v-if="lecture.type === 'qna'" class="qna-badge">Q&amp;A</span>
                    <h3>{{ lecture.title }}</h3>
                  </div>
                  <p class="speakers">{{ lecture.speakers.join(', ') }}</p>
                </div>
                <router-link
                  v-if="lecture.available"
                  class="replay-link"
                  :to="{ name: 'CourseReplayPage', params: { lectureId: String(lecture.id) } }"
                >
                  <v-btn color="primary" elevation="0" class="replay-button">
                    <v-icon left>mdi-play-circle-outline</v-icon>
                    다시보기
                  </v-btn>
                </router-link>
                <div v-else class="replay-link">
                  <v-btn disabled elevation="0" class="replay-button">
                    <v-icon left>mdi-play-circle-outline</v-icon>
                    다시보기
                  </v-btn>
                </div>
              </article>
            </div>

            <div v-if="session.break_after" class="break-row">
              <span class="schedule-time">{{ session.break_after.time }}</span>
              <span>{{ session.break_after.title }}</span>
            </div>
          </div>

          <div class="ceremony-row closing-row">
            <span class="schedule-time">{{ program.closing.time }}</span>
            <strong>{{ program.closing.title }}</strong>
          </div>
        </section>

        <section class="rating-note">
          <p v-for="note in program.rating_notes" :key="note">{{ note }}</p>
        </section>
      </template>
    </main>

    <v-footer class="Dashboard__footer">
      <span>한국지질동맥경화학회 - 교육위원회</span>
    </v-footer>
  </div>
</template>

<script>
import Headertitle from '@/components/app/user/Headertitle.vue';
import VodApi from '@/api/vod/VodApi';

export default {
  components: {
    Headertitle,
  },
  data() {
    return {
      program: null,
      loading: false,
      errorMessage: '',
    };
  },
  mounted() {
    this.fetchProgram();
  },
  methods: {
    async fetchProgram() {
      this.loading = true;
      this.errorMessage = '';
      try {
        this.program = await VodApi.fetchProgram();
      } catch (error) {
        this.errorMessage = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : '프로그램을 불러오지 못했습니다.';
      } finally {
        this.loading = false;
      }
    },
    formatDate(value) {
      if (!value) return '';
      return value.slice(0, 16).replace(/-/g, '.');
    },
  },
};
</script>

<style scoped>
.replay-program-page {
  min-height: 100vh;
  background: #f4f6fb;
}

.program-main {
  width: min(1180px, calc(100% - 48px));
  margin: 0 auto;
  padding: 36px 0 88px;
}

.program-state {
  min-height: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #676b75;
}

.program-intro {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 24px;
}

.program-intro .eyebrow {
  margin: 0 0 6px;
  color: #3656c9;
  font-weight: 700;
}

.program-intro h1 {
  margin: 0;
  font-size: 32px;
  color: #242833;
}

.program-intro .period {
  margin: 8px 0 0;
  color: #6b7280;
}

.program-table {
  overflow: hidden;
  border: 1px solid #dce1ec;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 30px rgba(28, 45, 94, 0.07);
}

.session-block + .session-block {
  border-top: 10px solid #f4f6fb;
}

.session-header {
  display: flex;
  background: #dfe7fb;
}

.session-number {
  width: 125px;
  flex: 0 0 125px;
  display: flex;
  align-items: center;
  padding: 20px;
  background: #3656c9;
  color: white;
  font-weight: 700;
}

.session-heading {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 20px;
}

.session-heading h2 {
  margin: 3px 0 0;
  color: #27334f;
  font-size: 19px;
  line-height: 1.4;
}

.session-time {
  color: #3656c9;
  font-size: 13px;
  font-weight: 700;
}

.chair {
  margin: 0;
  text-align: right;
  color: #5e6881;
  font-size: 14px;
  white-space: nowrap;
}

.lecture-row {
  display: grid;
  grid-template-columns: 125px minmax(0, 1fr) 132px;
  align-items: center;
  border-bottom: 1px solid #e4e7ee;
}

.lecture-row:last-child {
  border-bottom: 0;
}

.schedule-time {
  padding: 18px 20px;
  color: #374151;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.lecture-content {
  min-width: 0;
  padding: 14px 20px;
  border-left: 1px solid #edf0f5;
}

.lecture-title-line {
  display: flex;
  align-items: center;
  gap: 8px;
}

.lecture-title-line h3 {
  margin: 0;
  color: #222733;
  font-size: 16px;
  line-height: 1.45;
}

.qna-badge {
  flex: 0 0 auto;
  padding: 2px 7px;
  border-radius: 10px;
  background: #eef2ff;
  color: #3656c9;
  font-size: 11px;
  font-weight: 700;
}

.speakers {
  margin: 5px 0 0;
  color: #657087;
  font-size: 13px;
}

.replay-link {
  padding: 12px 16px;
  text-decoration: none;
}

.replay-button {
  width: 100%;
  color: #fff !important;
}

.break-row,
.ceremony-row {
  display: grid;
  grid-template-columns: 125px 1fr;
  align-items: center;
  color: #6f7686;
  background: #f6f7f9;
}

.ceremony-row {
  background: #253f72;
  color: #fff;
}

.ceremony-row .schedule-time {
  color: inherit;
}

.closing-row {
  border-top: 10px solid #f4f6fb;
}

.rating-note {
  margin-top: 18px;
  padding: 18px 22px;
  border-radius: 12px;
  background: #fff;
  color: #687084;
  font-size: 13px;
}

.rating-note p {
  margin: 3px 0;
}

@media (max-width: 820px) {
  .program-main {
    width: calc(100% - 24px);
    padding-top: 20px;
  }

  .program-intro {
    display: block;
  }

  .session-header {
    display: block;
  }

  .session-number {
    width: auto;
    display: inline-flex;
    margin: 14px 14px 0;
    padding: 5px 10px;
    border-radius: 14px;
    font-size: 12px;
  }

  .session-heading {
    display: block;
    padding: 10px 14px 16px;
  }

  .chair {
    margin-top: 8px;
    text-align: left;
    white-space: normal;
  }

  .lecture-row {
    grid-template-columns: 1fr;
    padding: 14px;
  }

  .schedule-time,
  .lecture-content,
  .replay-link {
    padding: 0;
  }

  .lecture-content {
    margin-top: 8px;
    border-left: 0;
  }

  .replay-link {
    margin-top: 12px;
  }

  .replay-button {
    width: auto;
  }

  .break-row,
  .ceremony-row {
    grid-template-columns: 105px 1fr;
    padding: 13px 14px;
  }

  .break-row .schedule-time,
  .ceremony-row .schedule-time {
    padding: 0;
  }
}
</style>
